import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Container,
  Grid,
  Paper,
  TablePagination,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import MaterialTable, { Column, MTableEditRow } from "material-table";
import Moment from "react-moment";
import "moment/locale/ko";

import { useQuery } from "@apollo/client";
import {
  GET_NOTICES,
  GET_NOTICES_BY_CONDITION,
  GET_NOTICES_LIMIT,
} from "../../../../quries/notice";
import BoardListFile from "./BoardListFile";
import BoardPagination from "./BoardPagination";
import BoardSearchiField from "./BoardSearchiField";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  noticeList: {
    fontSize: 16,
    fontFamily: "Noto Sans Kr",
    fontWeight: 400,
    borderTop: "1px solid #CCC",
    // borderBottom: "1px solid #CCC",
    paddingTop: 8,
    paddingBottom: 8,
    [theme.breakpoints.down("xs")]: {},
  },
  noticeUnderList: {
    fontSize: 16,
    fontFamily: "Noto Sans Kr",
    fontWeight: 400,
    // borderBottom: "1px solid #CCC",
    "& > :first-child": {
      // borderTop: "none",
    },
    "& > :last-child": {
      borderBottom: "1px solid #CCC",
    },
  },

  topTitle: {
    fontWeight: 900,
    [theme.breakpoints.down("xs")]: { paddingTop: 4 },
  },
  dayZone: {
    fontSize: 16,
    letterSpacing: -1,
    textAlign: "right",
    paddingRight: 32,
    [theme.breakpoints.down("xs")]: { paddingRight: 8 },
  },
  idZone: {
    textAlign: "left",
    fontSize: 16,
    letterSpacing: -1,
    paddingLeft: 16,
  },
  titleZone: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowWrap: "normal",
    overflow: "hidden",
    paddingRight: 16,
    paddingLeft: 32,
    [theme.breakpoints.down("xs")]: { paddingLeft: 8 },
  },
  searchZone: {
    [theme.breakpoints.down("xs")]: { paddingBottom: 16, width: "100%" },
  },
}));

interface BoardUnderListGroupProps {
  // idNum: number;
  // title: string;
  // date: any;
  match: any;
  history: any;
}
interface BoardListGroupProps {
  idNum: number;
  title: String;
  date: any;
  fileArr: any;
}

interface fileType {
  mime: String;
}

interface BoardArr {
  idNum: number | null;
  title: String;
  date: String;
  fileArr: fileType[];
}

function BoardListGroup({ match, history }: BoardUnderListGroupProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));

  const [state, setState] = useState<any[]>([]);
  const [searchKeyword, setSearchKeyword] = useState<any>();

  const [pageIndex, setPageIndex] = useState<any>(null);
  // const { data, loading, error } = useQuery(GET_NOTICES);

  const limitQuery = useQuery(GET_NOTICES_LIMIT, {
    variables: {
      fetchPolicy: "no-cache",
      limit: 10,
      start: (match.params.pageIndex - 1) * 10,
      sort: "notice_date:DESC",
    },
  });

  useEffect(() => {
    if (match.params.pageIndex === undefined) {
      setPageIndex(1);
    } else {
      let num: number = parseInt(match.params.pageIndex);
      setPageIndex(num);
    }
    return () => {
      setPageIndex(null);
    };
  }, [match.params.pageIndex]);

  useEffect(() => {
    if (limitQuery.data && limitQuery.data.notices) {
      let notices = limitQuery.data.notices;
      notices.forEach((notice: any) => {
        let arr = notice.notice_file;
        setState((prev: any) => {
          return [
            ...prev,
            {
              idNum: notice.id,
              title: notice.title,
              date: notice.notice_date,
              fileArr: notice.notice_file,
            },
          ];
        });
      });
    }
    return () => {
      setState([]);
    };
  }, [limitQuery.data]);

  if (limitQuery.loading) return null;
  if (limitQuery.data === undefined) return null;
  if (limitQuery.error || !limitQuery.data.notices) {
    console.log(limitQuery.error);
  }

  return (
    <div>
      <Grid xs={12} item container>
        <Grid
          xs={!mdMatches ? 10 : 12}
          item
          style={{ paddingBottom: !mdMatches ? 32 : 8 }}
        >
          <h6 className={classes.topTitle}>노동인권문화제 공지사항</h6>
        </Grid>
        <Grid xs={!mdMatches ? 2 : 12} item className={classes.searchZone}>
          <BoardSearchiField
            setSearchKeyword={setSearchKeyword}
            match={match}
            history={history}
          />
        </Grid>
      </Grid>

      <Grid className={classes.noticeUnderList}>
        {state.length > 0 ? (
          state.map((element: any, index: any) => {
            return (
              <div key={`notice-list-${element.idNum}-${index}`}>
                <BoardList
                  idNum={element.idNum}
                  title={element.title}
                  date={element.date}
                  fileArr={element.fileArr}
                />
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </Grid>

      <Grid xs={12} item container justify={"center"}>
        <BoardPagination
          setPageIndex={setPageIndex}
          pageIndex={pageIndex}
          history={history}
        />
      </Grid>
    </div>
  );
}

function BoardList({ idNum, title, date, fileArr }: BoardListGroupProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div>
      <Grid
        xs={12}
        item
        container
        component={"li"}
        className={classes.noticeList}
      >
        {/* <Grid
          xs={!mdMatches ? 1 : 2}
          item
          // container
          // alignItems="center"
          // justify="center"
          className={classes.idZone}
        >
          {idNum}
        </Grid> */}
        <Grid
          xs={!mdMatches ? 9 : 7}
          item
          // container
          // alignItems="center"
          // justify="center"
          // container
          className={classes.titleZone}
        >
          <Link to={`/notice/view/${idNum}`}>{title}</Link>
        </Grid>
        {!mdMatches ? (
          <Grid
            xs={1}
            item
            container
            style={{ display: "flex", height: 24, overflow: "hidden" }}
          >
            {/* {title} */}
            {fileArr && fileArr.length > 0 ? (
              fileArr.map((file: any, index: any) => {
                return (
                  <BoardListFile
                    file={file}
                    key={`notice-file-${file.id}-${index}`}
                  />
                );
              })
            ) : (
              <div></div>
            )}
          </Grid>
        ) : null}

        <Grid
          xs={!mdMatches ? 2 : 5}
          item
          // container
          // alignItems="center"
          // justify="center"
          className={classes.dayZone}
        >
          <Moment
            locale="ko"
            format={`${!mdMatches ? "YYYY년 MMM Do" : "YY년 MMM Do"}`}
          >
            {date}
          </Moment>
          {/* {date} */}
        </Grid>
      </Grid>
    </div>
  );
}

export default BoardListGroup;
